import { useEffect, useRef, useState } from "react"
import { useDevice, useError, useLiffToken, useLocation, useUser } from "@/app/store"
import { ChevronDownIcon } from "@heroicons/react/20/solid"
import Button from "@/app/components/Button"
import Popup from "@/app/components/popup"
import classNames from "classnames"

const DEBUG_MODE = process.env.DEBUG_MODE

const MessageBlock = (props: {
    message: any
    title: string
    titleClassName?: string
    canCopy?: boolean
    defaultShow?: boolean
}) => {

    const { message, title, titleClassName, canCopy, defaultShow } = props
    const [ show, setShow ] = useState(defaultShow || false)
    
    if (message) return (
        <div className="py-4">
            <button
                className={classNames('flex-center gap-2 text-main font-bold', titleClassName)}
                onClick={() => {setShow(!show)}}
            >
                <div>
                    {title}
                </div>
                <ChevronDownIcon className={classNames('w-6 transition', {
                    'rotate-[180deg]': !show
                })} />
            </button>
            <p
                className={classNames('whitespace-pre text-[0.75rem]', {
                    'hidden': !show
                })}
                onClick={() => { canCopy && navigator.clipboard.writeText(message)}}
            >
                {message}
            </p>
        </div>
    )
}

const DebugMessage = (props: { setMsgShow: Function }) => {

    const { setMsgShow } = props
    const liffToken = useLiffToken().token
    const user = useUser().data
    const location = useLocation()
    const device = useDevice()
    const debugMsg = useError().debugMsg

    return (
        <Popup
            contentClassName="flex flex-col gap-6"
            close={() => {setMsgShow(false)}}
        >
            <div className="w-full divide-y overflow-auto">
                <MessageBlock
                    title="Error message"
                    titleClassName="text-red-500"
                    message={debugMsg && JSON.stringify(debugMsg, null, 4)}
                    defaultShow
                />
                <MessageBlock
                    title="User Account"
                    message={JSON.stringify(user?.account, null, 4)}
                />
                <MessageBlock
                    title="Device Orientation Permission"
                    message={device.orientationPermission}
                />
                <MessageBlock
                    title="Location Location"
                    message={JSON.stringify(location?.geo, null, 4)}
                />
                <MessageBlock
                    title="Location Weather"
                    message={JSON.stringify(location?.weather, null, 4)}
                />
                { DEBUG_MODE === 'true' &&
                    <MessageBlock
                        title="Liff token"
                        message={liffToken}
                        canCopy
                    />
                }
            </div>
            <Button
                className="btn-secondary w-full"
                onClick={() => {throw new Error('Test Error')}} // ???
            >Test Error</Button>
            <Button
                className="btn-main w-full"
                onClick={() => {setMsgShow(false)}}
            >關閉</Button>
        </Popup>
    )
}
const DebugButton = (props: { setMsgShow: Function }) => {

    const { setMsgShow } = props
    const [ debugClick, setDebugClick ] = useState('')
    const debugTimeout = useRef<NodeJS.Timeout>(null)

    useEffect(() => {
        handleDebugClick()
    }, [debugClick])

    function handleDebugClick() {
        if (debugClick !== '') {
            if (!debugTimeout.current) {
                debugTimeout.current = setTimeout(() => {
                    setDebugClick('')
                    clearTimeout(debugTimeout.current)
                    debugTimeout.current = null
                }, 1000)
            }
        }
        if (debugClick.length >= 4) {
            setDebugClick('')

            if (DEBUG_MODE === 'true' && debugClick === '1111') {
                setMsgShow(true)
            }
            else if (debugClick === '1212') {
                setMsgShow(true)
            }
        }
    }

    return (
        <>
        <button
            className={classNames('fixed top-12 left-0 w-10 h-10 aspect-square z-[1000]', {
                'opacity-50 bg-red-300': DEBUG_MODE === 'true',
                'opacity-0': DEBUG_MODE !== 'true'
            })}
            onClick={() => {setDebugClick(debugClick + '1')}}
        ></button>
        <button
            className={classNames('fixed top-12 right-0 w-10 h-10 aspect-square z-[1000]', {
                'opacity-50 bg-red-300': DEBUG_MODE === 'true',
                'opacity-0': DEBUG_MODE !== 'true'
            })}
            onClick={() => {setDebugClick(debugClick + '2')}}
        ></button>
        <div className={classNames('fixed bottom-1 left-1/2 -translate-x-1/2 pointerevents-none z-[1000]', {
            'opacity-50': DEBUG_MODE === 'true',
            'opacity-0': DEBUG_MODE !== 'true'
        })}>
            { debugClick }
        </div>
        </>
    )
}
export default function Debug() {

    const [ msgShow, setMsgShow ] = useState(false)

    return (
        <>
        { msgShow && <DebugMessage setMsgShow={setMsgShow} /> }
        <DebugButton setMsgShow={setMsgShow} />
        </>
    )
}